export const workExperience = {
    'Accenture': {
        // Client-1
        'Microsoft': [
            "Migrated Microsoft’s Azure Support Center Authoring tool web design to create a unified supportability improvement platform. (React, TypeScript, Redux)",
            "Designed web interface for Microsoft’s internal product to reduce mitigation time for escalations and alleviate customer pain. (React, TypeScript, Redux)",
            "Designed web interface for Microsoft’s internal product to manage support engineers procedures and checklists. (React, TypeScript, Redux)",
            "Developed internal software for Microsoft’s Azure Cloud business to automate the troubleshooting process for Azure support engineers. (Node.js)"
        ],
        'Intel': [
            "Currently working on a web portal providing a one-stop solution for all IT automation needs. (React.js, Node.js, MSSQL)",
        ],
    },
    'Tata Consultancy Services (TCS)': {
        // Client-1
        'Standard Chartered GBS':[
            "Collaborated on the migration of applets to a rich user interface for Standard Chartered Bank’s core banking application. (React, JavaScript)",
            "Successfully migrated around 20 applets to the new rich user interface which were deployed in 40 countries.",
            "Designed and developed a reusable framework for the migration of applets to a rich user interface which has been utilized by over 50 developers within Standard Chartered Bank’s core banking system. (React, JavaScript)"
        ],
    }
}